import Vue from 'vue';
import {Model} from '@vuex-orm/core';
import moment from 'moment';
import Application from "$src/models/applicationModel";
import store from '$src/store';

export default class User extends Model {

    static entity = 'user';
    static primaryKey = 'id_user';

    static fields() {
        return {
            id_user: this.number(null),
            id_file_image: this.attr(null),
            gender: this.attr(null),
            first_name: this.string(''),
            last_name: this.string(''),
            email: this.string(''),
            status: this.number(0),
            role_ids: this.string(''),
            birth_date: this.attr(null),
            address: this.attr({
                street: null,
                street_number: null,
                post_code: null,
                city: null,
                country: null,
            }),
            country_state: this.attr(null),
            _entityAuth: this.attr({}),
            application: this.belongsTo(Application, 'id_user', 'id_user'),
            visible_wiki_groups: this.attr([]),
            current_balance: this.number(null),
            onboarding_type: this.number(0),
            onboarding_status: this.number(0),
            program_start_at: this.attr(null),
            program_leave_at: this.attr(null),
            pr_restrictions: this.boolean(null),
            accounting_id: this.attr(null),
            tags: this.attr({}),
            email_signature: this.attr(null),
            funded_by: this.attr(null),
        };
    }

    get fullname() {
        return `${this.first_name} ${this.last_name}`;
    }

    get countryStateString() {
        return Vue.__(`country_state/${this.country_state}`);
    }

    get isFirstYear() {
        return moment(this.program_start_at).isSame(new Date(), "year");
    }

    get roles() {
        if (this.role_ids.length > 0) {
            return this.role_ids.split(',').map(id_role => store.getters['auth/getRoleById'](id_role));
        }
        return [];
    }

    get rolesString() {
        return this.roles.map(role => role.label).join(', ');
    }

    get profileImage() {
        return Vue.$img(this.id_file_image, '/img/user.jpg');
    }

    get age() {
        return this.birth_date === null ? 0 : moment().diff(moment(this.birth_date), 'years');
    }

    get birthDateString() {
        return this.birth_date === null ? 'Keine Angabe' : moment(this.birth_date).format('D. MMMM YYYY');
    }

    get link() {
        return {
            route: 'community_profile',
            params: {id_user: this.id_user},
        };
    }

    get post_code() {
        return this.address.post_code || "Keine Angabe";
    }

    static make() {
        return Object.entries(this.fields()).reduce((result, [name, field]) => {
            result[name] = field.value;
            return result;
        }, {});
    }

    hasRole(name) {
        return !!this.roles.find(role => role.name === name);
    }

    canAccessApplication() {
        if (!this.$can('access_application')) {
            return false;
        }

        if (this.isCoordinator && this.application.status > 1) {
            return true;
        }

        if (this.$is('admin') && this.application.status >= 1) {
            return true;
        }

        return false;
    }

    isCoordinator() {
        return this.$is('coordinator') || this.$is('lead_coordinator');
    }
}